import { Fragment } from 'react'

import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'
import ReactMarkdown from 'react-markdown'

import { components } from 'components/DefaultMdxComponents'

import { Attribute } from '../Attribute'
import { Container, Content, List, Wrapper } from '../Common'
// TODO: rewrite Example to be general enough to be used here
import { useApiContext } from '../context'
import { DeprecationContextProvider, useDeprecationContext } from '../Deprecation'
import { Container as ExampleContainer } from '../Example/Container'
import { SyntaxHighlighter } from '../Example/SyntaxHighlighter'
import { getPropertyValue } from '../getDeepReferences'

type Props = {
	title: string
	data: OpenApi3.MediaTypeObject

	linkPrefix: string
	definitions: Record<string, OpenApi3.SchemaObject | OpenApi3.ReferenceObject> | undefined
}

export const Schema = ({ title, data, definitions, linkPrefix }: Props) => {
	const { getRefValue } = useApiContext()
	// Consider adding a button to toggle deprecated values
	const deprecationContext = useDeprecationContext()
	if ('$ref' in data) {
		console.error('Rendering of referenced request or response objects are not yet supported')
		return null
	}

	if (!(data.schema && '$ref' in data.schema)) return null

	const schema = getRefValue(data.schema.$ref)

	return (
		<DeprecationContextProvider value={deprecationContext}>
			<Container>
				<Content prefix={linkPrefix} title={title} level={2}>
					<Wrapper>
						<div>
							{schema?.description && (
								<ReactMarkdown components={components}>
									{schema.description.replace(/DEPRECATED\{\{(?:.*\n*)*\}\}/, '').trimEnd()}
								</ReactMarkdown>
							)}
							<List>
								{(() => {
									if (schema && 'properties' in schema && schema.properties) {
										return (
											<Fragment>
												{Object.entries(schema.properties).map(([key, value], index) => (
													<Attribute
														key={index}
														name={key}
														value={value}
														isRequired={schema.required?.includes(key) ?? false}
														linkPrefix={`${linkPrefix}-${title.toLowerCase()}`}
														isExpandedInitially={Object.keys(schema.properties!).length === 1}
													/>
												))}
											</Fragment>
										)
									}
									if (schema) {
										return (
											<Attribute
												name=''
												value={schema}
												linkPrefix={`${linkPrefix}-${title.toLowerCase()}`}
												isRequired
											/>
										)
									}
								})()}
							</List>
						</div>
						<ExampleContainer>
							<SyntaxHighlighter language='json' fontSize={12}>
								{JSON.stringify(
									getPropertyValue({
										definitions,
										schema: getRefValue(data.schema.$ref)!,
										hideDeprecatedProperties: false,
									}),
									null,
									2,
								)}
							</SyntaxHighlighter>
						</ExampleContainer>
					</Wrapper>
				</Content>
			</Container>
		</DeprecationContextProvider>
	)
}
